export const getPicture = (state, ownProps) => state.pictures[ownProps.src];

export const getBreakpoints = state => state.breakpoints;
